// TODO: @tyleraadams validate form

/*
 // post json api/v1/newsletters
 var example_data_to_post = {
 "email": "yourmail@nomail.com",
 "fastcompany": {"Daily": true},
 "codesign": {"Daily": false},
 "cocreate": {"Daily": false},
 "coexist": {"Daily": false},
 "leadership": {"Daily": false},
 "technology": {"Weekly": false},
 "mostcreativepeople": false,
 "offers": false,
 "events": false
 };
 */
import $ from 'jquery';

export default function (selector) {
    const $form = $(selector).last();
    const action = $form.attr('action');
    const method = $form.attr('method');
    const $input = $form.find('input');
    const $messagesDiv = $form.parent('div').find('.messages');

    function disable() {
        $input.prop('disabled', true);
    }

    function enable() {
        $input.prop('disabled', false);
    }

    function emptyMessages() {
        $messagesDiv.empty();
    }

    function displayMessage(html) {
        emptyMessages();
        $messagesDiv.prepend(html);
    }

    function focus() {
        $form.find('#email').focus();
    }

    function prepareFormForAnotherSubmission(message) {
        let htmlMessage = '<p class="alert-box alert">' + message + '</p>';
        displayMessage(htmlMessage);
        enable();
        focus();
    }


    function _formSuccess(data) {
        let message;
        if (!$form) { return; }

        if (typeof data.response.errors !== 'undefined' && data.response.errors.length) {
            $(data.response.errors).each(function () {
                prepareFormForAnotherSubmission(this.message);
            });
        } else {
            message = '<p class="alert-box success">Thank you! Please check your inbox to confirm! </p>';
            displayMessage(message);
        }
    }

    function _formFail(error) {
        let message;
        if (!$form) {
            return;
        }
        // console.warn('error: ', error);
        message = JSON.parse(error.responseText);
        if (message.response && message.response.message) {
            message = message.response.message;
        // Error message not provided
        } else {
            message = 'Please enter a valid email address.';
        }

        if (message && (message.code === -100) || (message.code === 220)) {
            message = 'Please enter a valid email address.';
        }
        prepareFormForAnotherSubmission(message);
    }

    function sendFormData(data) {
        $.ajax({
            url: action,
            type: method,
            data: data,
            context: $form
        }).done(function (response) {
            _formSuccess(response);
        }).fail(function (error) {
            _formFail(error);
        });
    }

    function onSubmit(e) {
        e.preventDefault();
        const data = $form.serialize();

        disable();
        sendFormData(data);
    }

    function init() {
        $form.on('submit', onSubmit);
    }

    return {
        init: init
    };
}
